import { Button } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getKeyFrameCount } from "../../../redux/selectors";
import { clearLocations } from "../../../redux";
import { ReactComponent as ResetIcon } from "./reset.svg";
import { iconSize } from "../../../config";

function ResetButton() {
  const kfCount = useSelector(getKeyFrameCount);
  const dispatch = useDispatch();
  const reset = () => {
    dispatch(clearLocations());
  };
  const resetDisabled = kfCount === 0;
  return (
    <Button
      type="text"
      onClick={reset}
      icon={<ResetIcon width={iconSize} />}
      disabled={resetDisabled}
    >
      Reset
    </Button>
  );
}

export default ResetButton;
